import React from 'react';
import nodata from '../assets/icons/nodata.png';

const NoData = () => {
  return (
    <div className='w-[100%] h-[100%] flex flex-col justify-center items-center mt-10'>
        <img src={nodata} alt="No Data" className='w-[100px]'/>
        <span className='text-center dark:text-customWhite'>There is no data.</span>
    </div>
  )
}

export default NoData;